import React from "react";
import { Passengers } from "../OrderDetail/Passengers";

function ChangeDateConfirmationPassengers({ data }) {
  // console.log({ data });
  const booking = {
    flightBooking: [
      data?.changedFlightBooking || {
        travelers: data?.passengerInfo,
      },
    ],
  };

  // console.log({ booking, data });
  return (
    <div className="w-full">
      <Passengers
        order={{
          booking: booking,
        }}
      />
    </div>
  );
}

export default ChangeDateConfirmationPassengers;
